import Language from 'constants/Language';
import { DefaultSeoSettings } from 'constants/Default';

import {
  Action,
  Footer,
  NavList,
  NotificationBar,
  PopUp,
  ErrorPage,
  InputField,
  BusinessOnboarding,
  GeneralInquiry,
  SeoSettings,
  SurveyPages,
} from 'types';

export interface GlobalSettingsReducer {
  styleGuideLink: string;
  sideNavigation: NavList;
  notificationBar: NotificationBar;
  footer: Footer;
  popUp: PopUp;
  errorPage: ErrorPage;
  articleShareUserStory: {
    inputFields: InputField[];
    description: string;
    disclaimer: string;
  };
  businessOnboarding: BusinessOnboarding;
  generalInquiry: GeneralInquiry;
  seo: SeoSettings;
  instagramToken: string;
  surveyPages: SurveyPages;
}

const initialState: GlobalSettingsReducer = {
  styleGuideLink: '',
  sideNavigation: {},
  notificationBar: {
    isActive: false,
    text: '',
  },
  footer: {
    social: [],
    menu: [],
    termsSlug: '',
    privacySlug: '',
    cookiesSlug: '',
    footerImage: null,
  },
  popUp: {
    isActive: false,
    text: [],
    continueButtonLabel: '',
    secondaryButtonLabel: '',
    secondaryButtonLink: '',
  },
  errorPage: {
    title: Language.t('Global.errorPageDefaultTitle'),
  },
  articleShareUserStory: {
    inputFields: [],
    description: '',
    disclaimer: '',
  },
  businessOnboarding: {
    inputFields: [],
    popUpTitle: '',
    popUpDescription: '',
    popUpVideo: {
      vimeoId: '',
    },
  },
  generalInquiry: {
    inputFields: [],
    sectionTitle: '',
    sectionDescription: [],
    formDescription: '',
    submitFormToEmail: false,
  },
  seo: {
    title: DefaultSeoSettings.title,
    description: DefaultSeoSettings.description,
    image: {
      id: 'defaultSeoImage',
      src: DefaultSeoSettings.image,
      alt: '',
      crop: null,
      hotspot: null,
      metadata: null,
    },
  },
  instagramToken: '',
  surveyPages: {},
};

export default (
  state: GlobalSettingsReducer = initialState,
  action: Action
): GlobalSettingsReducer => {
  switch (action.type) {
    case 'FETCH_GLOBAL_SETTINGS_FULFILLED':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
